import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

interface IExternalLinkProps {
  link?: string;
}

export const ExternalLink: React.FC<IExternalLinkProps> = ({
  link
}) => {

  if (!link) return null;

  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon icon={faExternalLinkAlt} color='#0d6efd' size='1x' />
    </a>
  );
}